<mat-toolbar>
  <span>Cult Bot Knowledge Management</span>
  <span class="spacer"></span>
  <button mat-raised-button color="primary" (click)="startCreate()">
    <mat-icon>add</mat-icon>
    Create Page
  </button>
</mat-toolbar>

<mat-card>
  <mat-card-content>
    <!-- Loading Spinner -->
    @if (isLoading) {
      <div class="loading-container">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Loading knowledge base...</p>
      </div>
    }

    <!-- Results Summary -->
    @if (!isLoading && pages.length > 0) {
      <div class="results-summary">
        <mat-chip-set>
          <mat-chip>{{ pages.length }} page{{ pages.length === 1 ? '' : 's' }}</mat-chip>
          <mat-chip>{{ publishedCount }} published</mat-chip>
        </mat-chip-set>
      </div>
    }

    <!-- Pages Table -->
    @if (!isLoading && pages.length > 0) {
      <div class="table-container">
        <table mat-table [dataSource]="dataSource" class="pages-table">
          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let page"><code>{{ page.name }}</code></td>
          </ng-container>

          <!-- Description Column -->
          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef>Description</th>
            <td mat-cell *matCellDef="let page" class="description-cell">{{ page.description }}</td>
          </ng-container>

          <!-- Published Column -->
          <ng-container matColumnDef="published">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let page">
              @if (page.published) {
                <mat-chip color="primary">Published</mat-chip>
              } @else {
                <mat-chip>Unpublished</mat-chip>
              }
            </td>
          </ng-container>

          <!-- Updated At Column -->
          <ng-container matColumnDef="updated_at">
            <th mat-header-cell *matHeaderCellDef>Last Updated</th>
            <td mat-cell *matCellDef="let page">{{ page.updated_at }}</td>
          </ng-container>

          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let page" class="actions-cell">
              <button
                mat-icon-button
                color="primary"
                (click)="startEdit(page)"
                matTooltip="Edit page">
                <mat-icon>edit</mat-icon>
              </button>
              <button
                mat-icon-button
                color="warn"
                (click)="startDelete(page)"
                matTooltip="Delete page">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    }

    <!-- No Results -->
    @if (!isLoading && pages.length === 0) {
      <div class="no-results">
        <mat-icon>menu_book</mat-icon>
        <h3>No knowledge base pages yet</h3>
        <p>Cult Bot's AI can look up reference pages on demand. Create the first one to get started.</p>
        <button mat-raised-button color="primary" (click)="startCreate()">
          <mat-icon>add</mat-icon>
          Create First Page
        </button>
      </div>
    }
  </mat-card-content>
</mat-card>
